import {Box} from '@mui/material';
import {messages} from '@smartmixin/i18n';
import React from 'react';
import {useIntl} from 'react-intl';

export const MAIN_CONTENT_ID = 'main-content';

/**
 * The first focusable element on every page: hidden until it has keyboard
 * focus, then shown top-left; activating it moves focus to <main> (which is
 * tabIndex -1). Focus is moved in JS rather than by the #hash, which would
 * change the URL and collide with Help Centre heading anchors.
 */
export const SkipLink = () => {
  const {formatMessage} = useIntl();
  const onClick = React.useCallback((e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById(MAIN_CONTENT_ID)?.focus();
  }, []);
  return (
    <Box
      component="a"
      href={`#${MAIN_CONTENT_ID}`}
      onClick={onClick}
      sx={{
        position: 'fixed',
        top: 8,
        left: 8,
        zIndex: (t) => t.zIndex.tooltip + 1,
        px: 1.5,
        py: 1,
        borderRadius: 1,
        bgcolor: 'background.paper',
        color: 'ink.main',
        fontWeight: 600,
        fontSize: '0.875rem',
        textDecoration: 'underline',
        border: 1,
        borderColor: 'border.control',
        transform: 'translateY(-200%)',
        '&:focus-visible, &:focus': {transform: 'none'},
      }}>
      {formatMessage(messages.navigation.skipToContent)}
    </Box>
  );
};
